import {
  NOTIFICATIONS,
  UNIT,
  ROLES,
  PAYMENT_SLIPS,
  CONFIG,
  USER,
} from '../../../utils/constants';
import bus from '@/utils/bus';
import logTrace from '@/services/logTrace';
import enums from '../../../utils/enums';
import requestService from '../../../services/request';
import moment from 'moment-timezone';
const promisesCache = {};
export default {
  state: {
    toExpirePaymentSlips: null,
    byContractSlips: {},
    paymentSlipError: false,
    loading: false,
    hasLateSlips: false,
    hasFuturePaymentSlips: false,
    hasPayableLateSlips: false,
  },
  getters: {
    [PAYMENT_SLIPS.HAS_TO_EXPIRE_SLIPS]: (state) =>
      Array.isArray(state.toExpirePaymentSlips) &&
      state.toExpirePaymentSlips.length > 0,
    [PAYMENT_SLIPS.GET_TO_EXPIRE]: (state) => state.toExpirePaymentSlips,
    [PAYMENT_SLIPS.HAS_LATE_SLIPS]: (state) => state.hasLateSlips,
    [PAYMENT_SLIPS.HAS_PAYABLE_LATE_SLIPS]: (state) =>
      state.hasPayableLateSlips,
    [PAYMENT_SLIPS.HAS_FUTURE_SLIPS]: (state) => state.hasFuturePaymentSlips,
    [PAYMENT_SLIPS.HAS_SLIP_ERROR]: (state) => state.paymentSlipError,
    [PAYMENT_SLIPS.GET_IS_LOADING]: (state) => state.loading,
    [PAYMENT_SLIPS.GET_TO_EXPIRE_BY_CONTRACT]: (state, getters) =>
      state.byContractSlips,
    [PAYMENT_SLIPS.GET_TO_EXPIRE_ALLOWED_CONTRACTS]:
      (state, getters) => (fromNotifications) => {
        const financial = getters[CONFIG.GET].navigationRules.financial;

        const { allowedContractTypes: toExpireAllowedContracts } =
          financial.toExpireSlipRules;
        const { allowedContractTypes: lateAllowedContracts } =
          financial.lateSlipRules;

        const allowedContracts = getters[UNIT.GET_SELECTED].contracts.filter(
          (contract) =>
            toExpireAllowedContracts.includes(contract.type) ||
            (!fromNotifications && lateAllowedContracts.includes(contract.type))
        );
        return allowedContracts;
      },
  },
  mutations: {
    [PAYMENT_SLIPS.MUTATE_LOADING]: (state, payload) => {
      state.loading = payload;
    },
    [PAYMENT_SLIPS.MUTATE_ERROR]: (state, payload) => {
      state.paymentSlipError = payload;
    },
    [PAYMENT_SLIPS.MUTATE_TO_EXPIRE_PAYMENT_SLIPS]: (state, payload) => {
      state.toExpirePaymentSlips = payload;
    },
    [PAYMENT_SLIPS.MUTATE_TO_EXPIRE_SLIP]: (state, payload) => {
      if (!Array.isArray(state.toExpirePaymentSlips)) {
        return;
      }
      const slipIndex = state.toExpirePaymentSlips.findIndex(
        (slip) =>
          slip.serieId === payload.serieId &&
          slip.serieCode === payload.serieCode &&
          slip.parcelCode === payload.parcelCode
      );
      if (~slipIndex) {
        // slip found
        if (payload.remove) {
          state.toExpirePaymentSlips.splice(slipIndex, 1);
          for (
            let index = 0;
            index < state.byContractSlips[payload.contractId].length;
            index++
          ) {
            const slip = state.byContractSlips[payload.contractId][index];
            if (
              slip.serieId === payload.serieId &&
              slip.serieCode === payload.serieCode &&
              slip.parcelCode === payload.parcelCode
            ) {
              state.byContractSlips[payload.contractId].splice(index, 1);
            }
          }
        } else {
          state.toExpirePaymentSlips[slipIndex] = payload;
          for (
            let index = 0;
            index < state.byContractSlips[payload.contractId].length;
            index++
          ) {
            const slip = state.byContractSlips[payload.contractId][index];
            if (
              slip.serieId === payload.serieId &&
              slip.serieCode === payload.serieCode &&
              slip.parcelCode === payload.parcelCode
            ) {
              state.byContractSlips[payload.contractId][index] = payload;
            }
          }
        }
        state.toExpirePaymentSlips = state.toExpirePaymentSlips;
        bus.$emit('toExpireSlip:requestReady');
      }
    },
    [PAYMENT_SLIPS.HAS_LATE_SLIPS]: (state, payload) =>
      (state.hasLateSlips = payload),
    [PAYMENT_SLIPS.HAS_PAYABLE_LATE_SLIPS]: (state, payload) =>
      (state.hasPayableLateSlips = payload),
    [PAYMENT_SLIPS.HAS_FUTURE_SLIPS]: (state, payload) =>
      (state.hasFuturePaymentSlips = payload),
  },
  actions: {
    [PAYMENT_SLIPS.FETCH_TO_EXPIRE]: async (
      { commit, state, dispatch, getters },
      { fromNotifications = false } = {}
    ) => {
      try {
        if (
          getters[USER.GET_USER_ROLE] !== ROLES.CLIENT_ROLE ||
          getters[PAYMENT_SLIPS.GET_IS_LOADING]
        ) {
          return;
        }
        const unitObj = getters[UNIT.GET_SELECTED];
        if (!fromNotifications) {
          commit(PAYMENT_SLIPS.MUTATE_ERROR, false);
          if (!getters[PAYMENT_SLIPS.HAS_TO_EXPIRE_SLIPS]) {
            commit(PAYMENT_SLIPS.MUTATE_LOADING, true);
          }
        }

        const promises = [];
        const url = `${process.env.FINANCIAL_API_URL}/toExpire`;

        const allowedContracts =
          getters[PAYMENT_SLIPS.GET_TO_EXPIRE_ALLOWED_CONTRACTS](false);

        const allowedContractsFromNotifications =
          getters[PAYMENT_SLIPS.GET_TO_EXPIRE_ALLOWED_CONTRACTS](true);
        // ? Get all payment slips from this unit contracts
        for (const { id: contractId, type } of allowedContracts) {
          const params = {
            contractId,
            contractType: type,
          };
          const paramsKey = JSON.stringify(params);
          if (
            !promisesCache[paramsKey] ||
            moment().isAfter(promisesCache[paramsKey].validUntil)
          ) {
            promisesCache[paramsKey] = {
              validUntil: moment().add(5, 'minutes').toISOString(),
              promise: requestService(url, 'GET', {
                params,
                useLoading: false,
                localErrorHandling: true,
              }),
            };
          }
          promises.push(promisesCache[paramsKey].promise);
        }

        const unitPaymentSlipsResults = await Promise.all(promises);
        const toExpirePaymentSlips = [];
        const correctValueRequests = [];
        if (unitPaymentSlipsResults) {
          let i = 0;
          for (const contractResult of unitPaymentSlipsResults) {
            const contract = unitObj.contracts[i];
            const contractId = contract.id;
            state.byContractSlips[contractId] = contractResult.items.map(
              (parcel) => {
                const lastSlip = state.byContractSlips[contractId]
                  ? state.byContractSlips[contractId].find(
                      (slip) => parcel.documentCode == slip.documentCode
                    ) || {}
                  : {};
                return {
                  ...lastSlip,
                  ...parcel,
                  uId: `${contractId}-${parcel.serieId}-${parcel.parcelCode}`,
                };
              }
            );

            for (let parcel of contractResult.items) {
              if (!fromNotifications) {
                const slip = {
                  contractId,
                  ...parcel,
                };
                toExpirePaymentSlips.push(slip);
              }
            }

            i++;
          }

          commit(
            PAYMENT_SLIPS.MUTATE_TO_EXPIRE_PAYMENT_SLIPS,
            toExpirePaymentSlips
          );

          commit(
            NOTIFICATIONS.MUTATE_TO_EXPIRE_PAYMENT_SLIPS,
            getters[PAYMENT_SLIPS.GET_TO_EXPIRE]
          );

          state.hasLateSlips = unitPaymentSlipsResults.some(
            (o) => o.latePaymentSlipsLength > 0
          );
          state.hasPayableLateSlips = unitPaymentSlipsResults.some(
            (o) => o.latePayablePaymentSlipsLength > 0
          );
          state.hasFuturePaymentSlips = unitPaymentSlipsResults.some(
            (o) => o.hasFuturePaymentSlips
          );
        }
      } catch (err) {
        commit(PAYMENT_SLIPS.MUTATE_ERROR, true);
        console.error(err);
      } finally {
        commit(PAYMENT_SLIPS.MUTATE_LOADING, false);
      }
    },
    [PAYMENT_SLIPS.FETCH_CORRECT_VALUE]: async (
      { commit },
      { contractId, contractType, parcel, unitObj, mutateSlip = false }
    ) => {
      const params = {
        contractId,
        contractType,
      };
      const url = `${process.env.FINANCIAL_API_URL}/toExpire`;

      const paramsKey = JSON.stringify(params);
      if (
        !promisesCache[paramsKey] ||
        moment().isAfter(promisesCache[paramsKey].validUntil)
      ) {
        promisesCache[paramsKey] = {
          validUntil: moment().add(5, 'minutes').toISOString(),
          promise: requestService(url, 'GET', {
            params,
            useLoading: false,
            localErrorHandling: true,
          })
            .then((res) => {
              let logsData = {};

              const logtraceAdd = (logs) => {
                logTrace({
                  action: enums.logTraceActions.controlledLogInfo,
                  details: {
                    Information: {
                      logs,
                      date: moment(),
                      description:
                        '[PAYMENT_SLIPS.FETCH_CORRECT_VALUE]: async ({ commit }',
                    },
                  },
                });
              };

              const [item] = res.items;
              logsData['item'] = item;
              logsData['contractId'] = contractId;
              if (item) {
                const slip = {
                  ...item,
                  contractId,
                };
                if (mutateSlip) {
                  commit(PAYMENT_SLIPS.MUTATE_TO_EXPIRE_SLIP, slip);
                }

                logsData['message'] = 'contains item';
                logtraceAdd(logsData);

                return slip;
              } else {
                const slip = {
                  ...parcel,
                  contractId,
                  remove: true,
                };
                commit(PAYMENT_SLIPS.MUTATE_TO_EXPIRE_SLIP, slip);
                logsData['message'] = 'Does not contain item';
                logtraceAdd(logsData);
                return slip;
              }
            })
            .catch((err) => {
              throw err;
            }),
        };
      } else {
        let slip = await promisesCache[paramsKey].promise;
        commit(PAYMENT_SLIPS.MUTATE_TO_EXPIRE_SLIP, slip);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/paymentSlips/toExpireSlips.js